enum HistoricalItemType {
    Added = 4,
    Modified = 3,
    Deleted = 2
}

const HistoricalItemTypeMap: { [key: number]: string } = {};
HistoricalItemTypeMap[HistoricalItemType.Added] = "Created";
HistoricalItemTypeMap[HistoricalItemType.Modified] = "Updated";
HistoricalItemTypeMap[HistoricalItemType.Deleted] = "Deleted";

export { HistoricalItemType, HistoricalItemTypeMap };
